import { useDispatch } from 'react-redux';
import { useAsyncAction } from 'Hooks/Common';
import { Document } from 'Interfaces/Document';
import { $actions } from 'Store/ducks';

export default () => {
  const dispatch = useDispatch();

  return useAsyncAction((documentIds: Document['id'][]) =>
    $actions.document.deleteDocuments(dispatch, { documentIds }),
  );
};
